import { TFunction } from 'i18next';

import { DominoAxiosResponse } from './workflow/base';

import { ErrorCode } from '@domui-utils/ErrorCode';

import { UnreachableCaseError } from '@typings/util';

export type Error = {
  statusText: string;
  data: { wfRes: { responseData: { detail: string } } };
  extensions: { code: string };
};

export const getClientErrorNotification = (
  error: DominoAxiosResponse,
  setErrorNotification: (code: ErrorCode, message: string) => void,
  t: TFunction
) => {
  switch (error?.data?.wfRes?.statusText) {
    case ErrorCode.Unauthorized:
      setErrorNotification(
        ErrorCode.Unauthorized,
        [
          t(
            'global.error.general',
            'There is a problem with this individual’s data. Please contact RI.'
          ),
        ]
          .concat(error.data.wfRes.responseData.detail || [])
          .join('\n')
      );
      break;

    // TODO: Use localizedNavigate here instead of
    //  window.location.replace, but make sure we don't have the
    //  following:
    //  - user session ends and ErrorCode.UserNotAuthenticated is
    //    thrown from getApolloContext
    //  - this code calls localizedNavigate('/login?...') and this
    //    initiates a navigation
    //  - another GraphQL request which was working in parallel is
    //    cancelled (probably by Gatsby?)
    //  - this generates a network error which is handled above in the
    //    "if (networkError)" condition
    //  - the handler calls localizedNavigate('/error')
    //  - result => user is redirected to /error

    default:
      throw new UnreachableCaseError(
        error.data.wfRes.responseData.detail as string
      );
  }
};
